<template>
  <a class="lesson-card" @click.prevent="study()" style="cursor: pointer;">
  <!-- <a class="lesson-card" @click.prevent="user ? study() : showLoginModal()" style="cursor: pointer;"> -->
    <div class="lesson-card__head" :style="lessonPreview">
      <div class="lesson-card__header-wrapper">
        <div class="lesson-card__numeration">{{ $t('lesson_numeration') }} {{ lesson.innerId }}</div>
        <div class="lesson-card__header">
          {{ lesson.title }}
        </div>
      </div>
    </div>
    <div class="lesson-card__body">
      <div v-if="completed" class="lesson-card__status lesson-card__status-completed lesson_status">
        <div class="lesson_status__icon lesson_status__icon-completed"><fa icon="check" fixed-width /></div>
        <label class="lesson_status__label lesson_status__label-completed">{{ $t('lesson_completed') }}</label>
        <div class="lesson_status__stars stars_block">
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result > 0 }"><fa icon="star" fixed-width /></span>
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result >= 0.34 }"><fa icon="star" fixed-width /></span>
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result >= 0.67 }"><fa icon="star" fixed-width /></span>
        </div>
      </div>
      <div v-if="!completed" class="lesson-card__status lesson-card__status-uncompleted lesson_status">
        <div class="lesson_status__icon lesson_status__icon-uncompleted" :title="$t('lesson_uncompleted')">
          <fa icon="question" fixed-width />
        </div>

        <label class="lesson_status__label lesson_status__label-uncompleted">{{ $t('lesson_uncompleted') }}</label>

        <div class="lesson_status__study">{{ $t('study_lesson') }}</div>
        <!-- <div class="lesson_status__study">{{ user ? $t('study_lesson') : $t('login') }}</div> -->
      </div>
    </div>
  </a>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "LessonCard",
    computed: mapGetters({
      user: 'auth/user',
    }),
    data: () => ({
      studying: false,
      result: 0,
      completed: false,
      lessonPreview: ''
    }),
    props: {
      lesson: {
        type: Object,
      },
      lessonId: {
        type: Number,
        default: 0
      },
      courseId: {
        type: Number,
        default: 0
      },
    },
    mounted () {
      if (this.user) {
        const userLesson = this.user.user_lessons.find(el => el.lesson_id === this.lessonId);
        if (userLesson) {
          this.studying = true;
          this.result = userLesson.result;
          this.completed = userLesson.result > 0;
        }
      }
      if (this.lesson.preview) {
        this.lessonPreview = 'background-image: url(/images/courses/' + this.courseId + '/lessons/' + this.lessonId + '/' + this.lesson.preview + ')'
      }
    },
    methods: {
      async study () {
        console.log(this.courseId, this.lessonId);
        if (this.user && !this.studying) {
          await this.$store.dispatch('auth/study', this.lesson);
        }
        console.log(this.courseId, this.lessonId);
        this.$router.push({ name: 'lesson.view', params: {courseId: this.courseId, id: this.lessonId} })
      },
      showLoginModal () {
        this.$store.dispatch('modals/showLogin');
      }
    }
  }
</script>
